import React, { createContext, useContext, useState } from 'react';
import { Alert } from '../../common/Alert';
import { ApolloLink, useApolloClient } from '@apollo/client';
import { onError } from "@apollo/client/link/error";
import { ErrorIds, FormErrors,  } from '@App/types/enums';
// Create the context
const ErrorHandlingContext = createContext<{
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
} | undefined>(undefined);

interface ApolloErrorHandlingProviderProps {
  children: React.ReactNode;
}

const GLOBAL_ERROR_MESSAGE = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Kontaktieren Sie uns bei Bedarf unter werkstattmeister@repareo.de';

export const ApolloErrorHandlingProvider: React.FC<ApolloErrorHandlingProviderProps> = ({ children }) => {
  const [error, setError] = useState<string | null>(null);

  const handledErrorMessages: string[] = [
    ...Object.values(ErrorIds),
    ...Object.values(FormErrors)
  ];

  const apolloClientWithErrorHandling = useApolloClient();

  const errorLink = onError((errorResponse) => {
    const { graphQLErrors, networkError } = errorResponse;

    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);

        // Check if the error message is one of the handled messages
        if (!handledErrorMessages.includes(message as string)) {
          setError(GLOBAL_ERROR_MESSAGE);
        }
      });
    }

    if (networkError) {
      console.error(`[Network error]: ${networkError}`);
    }
  });

  const existingLink = apolloClientWithErrorHandling.link;

  apolloClientWithErrorHandling.setLink(ApolloLink.from([errorLink, existingLink])); // append errorLink to existing links

  return (
    <ErrorHandlingContext.Provider value={{ error, setError }}>
      <Alert display={!!error} title={error} duration={5000} />
      {children}
    </ErrorHandlingContext.Provider>
  );
};

// Custom hook to use error context
export const useError = () => {
  const context = useContext(ErrorHandlingContext);

  if (!context) {
    throw new Error('useError must be used within an ApolloErrorHandlingProvider');
  }

  return context;
};